import app from '@/app';

function entityInjector(Entity, id, values) {
	return id && id !== 'new' ? Entity.get({ id: id }).$promise : new Entity(values);
}

app.factory('entityInjector', () => entityInjector);
